const required = (propertyType) => {
  return v => (v && v.length > 0) || `${propertyType} is required`
}
const rePassword = (oldpassword) => {
  return v => v === oldpassword || 'Passwords do not match'
}
export default {
  required,
  rePassword
}